import React, { useEffect, useRef, useState } from "react";
import CommonInput from "../../../CommonMethhods/CommonInput";
import { Hni_Admin_Api, Lead_Creation } from "../../../Configuration/API_URL";
import * as Yup from "yup";
import { toast } from "react-toastify";
import {
  AESEncryption,
  ApiResDecrypt,
} from "../../../CommonMethhods/CommonMethods";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import CommonSelect from "../../../CommonMethhods/CommonSelect";
import { useResumeContext } from "../../../CommonMethhods/Context";
import { useClientContext } from "../../../context/ClientContext";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function SegmentDetails(props) {
  const IndiMobileNo = localStorage.getItem("IndiMobileNo");
  const storeToken = localStorage.getItem("ssoToken");
  const resumeVal = props?.resumeVal;
  const masterValue = props?.masterValue;
  const { resumeHandle } = useResumeContext();
  const activeTab = props?.activeTab;
  const { selectedClient, shouldPrefill } = useClientContext();
  const [isDetailsSaved, setIsDetailsSaved] = useState(false);

  const errorSchema = Yup.object().shape({
    segmentValid: Yup.string().required("Segment is required"),
  });

  const {
    register,
    handleSubmit,
    watch,
    getValues,
    reset: resetForm,
    formState: { errors, isDirty, isValid },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(errorSchema),
  });

  const insertSegmentDetails = async (data) => {

    let payloadValue = {
      mobileNo: IndiMobileNo || resumeVal?.verificationDetails?.mobileNo,
      docName: data?.segmentValid
    };

    let encPayload = AESEncryption(payloadValue);
    try {
      const getRelation = await axiosInstance.post(
        Lead_Creation.segment_Activation,

        `"${encPayload}"`,
      );

      const res = ApiResDecrypt(getRelation?.data);
      if (res?.status === 0) {
        resumeHandle();
        toast.success(res?.data);
        setIsDetailsSaved(true);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const finalSubmit = (data) => {
    if (IndiMobileNo !== null || resumeVal?.verificationDetails?.mobileNo !== "") {
      insertSegmentDetails(data);
    }
  };

  useEffect(() => {
    const subscription = watch(() => {
      setIsDetailsSaved(false);
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    if (activeTab !== "individual") {
      resetForm({
        segmentValid: ""
      });
    } else if (
      shouldPrefill &&
      selectedClient?.mobile &&
      resumeVal?.segmentActivationDetails
    ) {
      resetForm({
        segmentValid: resumeVal?.segmentActivationDetails?.docName || "",
      });
    }
  }, [
    activeTab,
    shouldPrefill,
    selectedClient?.mobile,
    resumeVal,
  ]);

  return (
    <form className="individual-form-seg" onSubmit={handleSubmit(finalSubmit)}>
      <>
        <div className="row border-parent accordian-section-wrapper">
          <div className="col-sm-6 col-lg-3 card-accordian individiual-select lead-creation">
            <CommonSelect
              label="Segment"
              name="segmentValid"
              options={masterValue?.segmentActivationDocs}
              required
              register={register}
              value={getValues("segmentValid")}
            />
            <p className="forget-link add-error">
            <span>{errors?.segmentValid?.message}</span> 
        </p>
          </div>
          </div>
          <div className="wrap-button">
            <button type="submit" 
            className="val-btn-wrap"
              // className={`val-btn-wrap ${!isDirty || !isValid || isDetailsSaved ? "disable-btn" : ""}`}
              // disabled={!isDirty || !isValid || isDetailsSaved}
              >
              Save
            </button>
          </div>
      </>
    </form>
  );
}

export default SegmentDetails;
